import { render, staticRenderFns } from "./PanelTask.vue?vue&type=template&id=5d0ae11c&scoped=true&"
import script from "./PanelTask.vue?vue&type=script&lang=js&"
export * from "./PanelTask.vue?vue&type=script&lang=js&"
import style0 from "./PanelTask.vue?vue&type=style&index=0&id=5d0ae11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ae11c",
  null
  
)

export default component.exports